/* eslint-env browser */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import RouterComponent from './routes';
import configureStore from '../common/configure-store';

function bootstrap(state) {
  const store = configureStore(state);
  const root = createRoot(document.getElementById('react-root'));
  root.render(
    <Provider store={store}>
      <RouterComponent />
    </Provider>
  );
}

const initialState = window.__INITIAL_STATE__ || {};
bootstrap(initialState);
